var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5901",
    "data-name": "Group 5901",
    transform: "translate(-310 -15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6739",
    "data-name": "Rectangle 6739",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(310 15)",
    fill: "#056069"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6740",
    "data-name": "Rectangle 6740",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(310 24)",
    fill: "#056069"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6741",
    "data-name": "Rectangle 6741",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(310 33)",
    fill: "#056069"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu.6f8e4196.svg";
export { ForwardRef as ReactComponent };